<template>
    <div class="content-wrapper">
        <div class="row align-items-center">
            <div class="col-md-12 col-lg-6">
                <div class="d-flex align-items-center">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb p-0 d-flex align-items-center mb-primary">
                            <li class="breadcrumb-item page-header d-flex align-items-center">
                                <h4 class="mb-0">{{ $t('candidates.candidate_details') }}</h4>
                            </li>
                            <template v-if="this.$can('view_candidates')">
                                <li class="ml-2">|</li>
                                <li>
                                    <a :href="urlGenerator(candidateWebUrl)"
                                       class="btn btn-link text-primary pl-2">{{
                                            $t('candidates.back_to_all_candidates')
                                        }}</a>
                                </li>
                            </template>
                        </ol>
                    </nav>
                </div>
            </div>
            <div class="col-md-12 col-lg-6">
                <div class="d-flex justify-content-lg-end mb-primary">
                    <div class="dropdown">
                        <button type="button"
                                class="btn btn-success dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                            {{ $t('action') }}
                            <app-icon name="chevron-down"/>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                            <a href="#" class="dropdown-item" @click="editCandidate">
                                {{ $t('edit') }}
                            </a>

                            <a href="#" class="dropdown-item" @click="addCandidateNote">
                                {{ $t('candidates.add_note') }}
                            </a>

                            <a href="#" class="dropdown-item" @click.prevent="deleteCandidate">
                                {{ $t('delete') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="candidate-profile mb-primary">
            <div class="card card-with-shadow py-5 border-0" style="min-height: 220px;">
                <app-overlay-loader v-if="loader"/>
                <div v-else class="row">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-5">
                        <!-- Candidate Name Section (Updated to Match Other Sections) -->
                        <div class="media border-right px-5 candidate-header-media align-items-center">
                            <div class="media-body candidate-info-header">
                                <p class="text-muted mb-0">
                                    {{ $t('full_name') }}
                                </p>
                                <p class="">
                                    {{ candidate.first_name }} {{ candidate.last_name }}
                                </p>
                            </div>
                        </div>

                        <!-- Email Section -->
                        <div class="media mb-4 px-5 ">
                            <div class="media-body">
                                <p class="text-muted mb-0">
                                    {{ $t('email') }}
                                </p>
                                <p class="mb-0" v-if="candidate.email">
                                    {{ candidate.email }}
                                </p>
                                <p class="mb-0" v-else>
                                    {{ $t('not_added_yet') }}
                                </p>
                            </div>
                        </div>

                        <!-- Phone Number Section -->
                        <div class="media mb-4 px-5 mb-xl-5">
                            <div class="media-body">
                                <p class="text-muted mb-0">
                                    {{ $t('phone_number') }}
                                </p>
                                <p class="mb-0" v-if="candidate.phone_number">
                                    {{ candidate.phone_number }}
                                </p>
                                <p class="mb-0" v-else>
                                    {{ $t('not_added_yet') }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-7">
                        <div
                            class="candidate-details px-5 px-sm-5 px-md-5 px-lg-0 px-xl-0 mt-5 mt-sm-5 mt-md-0 mt-lg-0 mt-xl-0">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <div class="border-right custom">
                                        <!-- Department Section (Already Present) -->
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="briefcase"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">
                                                    {{ $t('department') }}
                                                </p>
                                                <p class="mb-0" v-if="candidate.department">
                                                    {{ candidate.department.name }}
                                                </p>
                                                <p class="mb-0" v-else>
                                                    {{ $t('not_added_yet') }}
                                                </p>
                                            </div>
                                        </div>
                                        <!-- Job Position Section (Already Present) -->
                                        <div class="media mb-4 mb-xl-5">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="tag"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">
                                                    {{ $t('job_position') }}
                                                </p>
                                                <p class="mb-0" v-if="candidate.job_position">
                                                    {{ candidate.job_position.title }}
                                                </p>
                                                <p class="mb-0" v-else>
                                                    {{ $t('not_added_yet') }}
                                                </p>
                                            </div>
                                        </div>
                                        <!-- Date of Birth Section (Already Present) -->
                                        <div class="media mb-4 mb-xl-0">
                                            <div class="align-self-center mr-3">
                                                <app-icon name="calendar"/>
                                            </div>
                                            <div class="media-body">
                                                <p class="text-muted mb-0">
                                                    {{ $t('date_of_birth') }}
                                                </p>
                                                <p class="mb-0" v-if="candidate.date_of_birth">
                                                    {{ formatDateTimeToLocalDate(candidate.date_of_birth) }}
                                                </p>
                                                <p class="mb-0" v-else>
                                                    {{ $t('not_added_yet') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                                    <!-- Address Details Section (Already Present) -->
                                    <div class="media mb-4 mb-xl-5">
                                        <div class="media-body">
                                            <p class="text-muted mb-0">
                                                {{ $t('address_details') }}
                                            </p>
                                            <p class="mb-0" v-if="candidate.address_details">
                                                {{ candidate.address_details }}
                                            </p>
                                            <p class="mb-0" v-else>
                                                {{ $t('not_added_yet') }}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- City Section (Already Present) -->
                                    <div class="media mb-4 mb-xl-5">
                                        <div class="media-body">
                                            <p class="text-muted mb-0">
                                                {{ $t('city') }}
                                            </p>
                                            <p class="mb-0" v-if="candidate.city">
                                                {{ candidate.city }}
                                            </p>
                                            <p class="mb-0" v-else>
                                                {{ $t('not_added_yet') }}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- Country Section (Already Present) -->
                                    <div class="media mb-0 mb-xl-0">
                                        <div class="media-body">
                                            <p class="text-muted mb-0">
                                                {{ $t('country') }}
                                            </p>
                                            <p class="mb-0" v-if="candidate.country">
                                                {{ candidate.country }}
                                            </p>
                                            <p class="mb-0" v-else>
                                                {{ $t('not_added_yet') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-tab :tabs="tabs" :icon="tabIcon"/>

        <app-candidate-modal
            v-if="isCandidateModalActive"
            v-model="isCandidateModalActive"
            :selected-url="updateUrl"
        />

        <app-candidate-note-modal
            v-if="isCandidateNoteModalActive"
            v-model="isCandidateNoteModalActive"
            :candidateId="candidateId.toString()"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
        />

    </div>
</template>

<script>
import {axiosDelete, urlGenerator} from '../../../../../common/Helper/AxiosHelper';
import {FormMixin} from "../../../../../core/mixins/form/FormMixin";
import CandidateCreateEditModal from "../../Recruitment/Candidate/CandidateCreateEditModal";
import {formatDateTimeToLocalDate} from "../../../../../common/Helper/Support/DateTimeHelper";
import {mapState} from "vuex";
import {CANDIDATES, CANDIDATEWEB} from "../../../../Config/ApiUrl";


export default {
    name: "CandidateDetails",
    mixins: [FormMixin],
    components: {CandidateCreateEditModal},
    props: {
        candidateId: {}
    },
    data() {
        return {
            candidate: {
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                department: {
                    name: ''
                },
                job_position: {
                    title: ''
                },
                date_of_birth: '',
                address_details: '',
                city: '',
                country: ''
            },
            candidateWebUrl: CANDIDATEWEB,
            urlGenerator,
            formatDateTimeToLocalDate,
            tabIcon: 'briefcase',
            viewCandidateModal: false,
            isCandidateModalActive: false,
            confirmationModalActive: false,
            isCandidateNoteModalActive: false,
            deleteUrl: '',
            promptAction: '',
            updateUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            tabs: [],
            candidateTabs: [
                {
                    'name': this.$t('notes'),
                    'title': this.$t('notes'),
                    'component': 'app-candidate-notes',
                    'props': {}
                },
            ]
        };
    },
    created() {
        this.tabs =  this.candidateTabs;
    },
    mounted() {
        // Fetch candidate details on component mount
        this.$store.dispatch("getCandidateDetails", this.candidateId);
    },
    methods: {
        cancelled() {
            this.confirmationModalActive = false;
        },

        editCandidate() {
            this.updateUrl = `${CANDIDATES}/${this.candidateId}`;
            this.isCandidateModalActive = true;
        },

        addCandidateNote() {
            this.isCandidateNoteModalActive = true;
        },

        // ✅ Delete candidate functionality
        deleteCandidate() {
            this.confirmationModalActive = true;
            this.deleteUrl = `${CANDIDATES}/${this.candidateId}`;
            this.promptAction = 'delete_candidate';
            this.promptTitle = this.$t('are_you_sure');
            this.promptMessage = this.$t('candidates.you_are_going_to_remove_an_candidate_from_list');
        },

        // ✅ Confirmation Modal Close
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
            // ✅ Redirect using urlGenerator
            window.location.href = urlGenerator(`${CANDIDATES}}`);
        },

        // ✅ Handles confirm button in modal
        triggerConfirm() {
            if (this.promptAction === 'delete_candidate') {
                this.removeCandidate(this.deleteUrl);
            }
        },

        // ✅ Delete request
        removeCandidate(url) {
            this.loading = true;

            axiosDelete(url)
                .then(({data}) => {
                    this.confirmationModalActive = false;
                    this.toastAndReload(data.message, 'candidate-table');
                })
                .catch(({response}) => {
                    this.toastException(response.data);
                    this.confirmationModalActive = false;
                })
                .finally(() => this.closeConfirmation());
        }
    },
    computed: {
        ...mapState({
            CandidateDetails: state => state.candidate.candidate,
            loader: state => state.loading,
        }),
    },
    watch: {
        CandidateDetails: {
            handler: function (candidate) {
                this.candidate = candidate;

                // Check if candidate.first_name exists
                if (candidate.first_name) {
                    // Ensure document.first_name is a string and exists
                    if (typeof document.first_name === 'string' && document.first_name) {
                        let firstName = document.first_name.split('-');
                        firstName[0] = candidate.first_name;
                        document.first_name = firstName.join(' - ');
                    } else {
                        // If document.first_name is undefined or not a string, initialize it properly
                        document.first_name = candidate.first_name;
                    }
                }
            },
            deep: true
        }
    }
};
</script>
